export function formatMoney(value) {
    return new Intl.NumberFormat('pt-BR', 
    { 
        style: 'currency', 
        currency: 'BRL', 
        maximumFractionDigits: 2 
    }).format(value)
}